import React, { Component } from 'react'

class YesNoResults extends Component {
  render () {
    const votes = !this.props.votes ? 1 : this.props.votes.length === 0 ? 1 : this.props.votes.length
    const yesVotes = !this.props.votes ? 0 : this.props.votes.filter(v => v.vote === 'yes').length
    const noVotes = !this.props.votes ? 0 : this.props.votes.filter(v => v.vote === 'no').length

    return (
      <div className='vote-results-container'>
        <div className='vote-results'>
          {yesVotes} vote{yesVotes === 1 ? '' : 's'} <span>({Math.floor((yesVotes / votes) * 100)}%)</span>
        </div>
        <div className='vote-results'>
          {noVotes} vote{noVotes === 1 ? '' : 's'} <span>({Math.floor((noVotes / votes) * 100)}%)</span>
        </div>
      </div>
    )
  }
}

export default YesNoResults



// WEBPACK FOOTER //
// ./src/screens/dashboard/chat/results/YesNoResults.js